export default __webpack_public_path__ + "static/media/audio.4e1e4149.mp3";